import { Filter } from 'components/Filter'
import { useHomeStore } from 'context/HomeStore'
import StandardTable from 'asterX-UI/Table/StandardTable'
import { Box, Grid } from '@material-ui/core'
import { Pagination } from 'asterX-UI/Pagination'
import { useRoutes } from 'lib/hooks'
import { CONTRACT_PATH } from 'routes/constants.routes'
import { InfoCard } from 'components/InfoCard/InfoCard'
import { SUCCESS_COLORS } from 'asterX-UI'
import { useAuthStore } from 'context/AuthStore'
import ContractCard from 'components/ContractCard/ContractCard'
import { MainTabs } from '../../MainTabs'
import { renewableContractsColumns, renewableContractsRows } from './const'

const RenewableContracts = () => {
  const { authStore } = useAuthStore()
  const { homeStore, homeStoreFunc } = useHomeStore()
  const routes = useRoutes()

  const tableData = {
    columns: renewableContractsColumns(homeStoreFunc),
    rows: renewableContractsRows(homeStore?.contractList)
  }

  const handleOpenContract = row => {
    const rowData = row.find(item => item?.isButton)
    const current = homeStore.contractList.find(e => e?.id === rowData?.data?.id)

    routes.goTo(`${CONTRACT_PATH}/${current?.id}`)
  }

  const renderCardView = () => {
    return (
      <Box display="flex" flexDirection="column" style={{ gap: 16, marginBottom: 10 }}>
        {homeStore?.contractList?.map(item => (
          <ContractCard key={item?.id} item={item} />
        ))}
      </Box>
    )
  }

  return (
    <MainTabs>
      <Grid item container spacing={2} style={{ marginBottom: 16 }}>
        <Grid xs={12} lg={4} xl={3} item>
          <InfoCard
            label="Завершенные контракты"
            value={homeStore?.infoCard?.countFiltered}
            color={SUCCESS_COLORS[600]}
          />
        </Grid>
      </Grid>
      <Filter page="renewableContracts" />

      {authStore.isMobile ? (
        renderCardView()
      ) : (
        <StandardTable
          tableData={tableData}
          onRowClick={handleOpenContract}
          btnStyle={{ backgroundColor: 'transparent', border: 'none', padding: 8, minWidth: 'auto', cursor: 'pointer' }}
        />
      )}
      <Grid item xs={12}>
        <Pagination
          count={Math.ceil(homeStore?.pagination?.count / 30)}
          page={homeStore?.pagination?.offset + 1}
          onChange={homeStoreFunc.handlePaginationChange}
          isMobile={authStore.isMobile}
        />
      </Grid>
    </MainTabs>
  )
}

export default RenewableContracts
